import { Box, Button, Stack, Tab, Typography } from "@mui/material";
import ReportFiltersComponent from "../ReportFiltersComponent";
import ReportScreen from "../../../../common/enums/ReportScreens";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import ReportFiltersLoading from "../ReportFiltersLoading";
import { ReportFilters } from "../../../../domain/models/report-filters";
import moment from "moment";
import { useEffect, useState } from "react";
import DataSummary from "./sub-component/DataSummary";
import RegionWiseDailyVisit from "./sub-component/RegionWiseDailyVisit";
import {
  DailyVisitReportType,
  FetchMonthlyVisitReportType,
} from "../../../../domain/models/daily-visit-report/dailyVisitReport";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { DownloadJSON } from "../../../../domain/models/daily-visit-report/downloadJSON";
import * as XLSX from "xlsx";
import { TerritoryData } from "../../../../domain/models/territory-data";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import { FetchDailyVisitReportStore } from "../../../../store/main/DailyVisitReportStore";
import {
  FetchSummaryVisitReportType,
  VisitSummaryType,
} from "../../../../domain/models/daily-visit-report/daily-visit-summary-report";
import DailyVisitSummaryLoading from "../DailyVisitSummaryLoading";
import DailyVisitTabCalendarLoader from "../DailyVisitTabCalendarLoader";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { ReportFiltersComponentStore } from "../../../../store/main/ReportFilterComponentStore";
import Roles from "../../../../common/enums/Roles";

type MonthlyVistParams = {
  customer_type_id?: string;
  ga_code?: string;
};

type SummaryVisitParams = {
  month: string;
  year: number;
  customer_type_id?: string;
  ga_code?: string;
};

const DailyVisitReportTable = () => {
  const { userDetails, userRole, decodeToken } = CustomerDatabaseStore();
  const { zoneMasterData } = TerritoryDataStore();

  const {
    FetchMonthlyVisitReport,
    FetchMonthlyVisitReportState,
    fetchMonthlyVisitReport,
    FetchSummaryVisitReport,
    FetchSummaryVisitReportState,
    fetchSummaryVisitReport,
  } = FetchDailyVisitReportStore();

  const {
    fetchReportFiltersComponent,
    resetReportFiltersComponent,
    reportFiltersComponent,
  } = ReportFiltersComponentStore();

  const currentDate = new Date();
  const [monthlyVisitOrders, setMonthlyVisitOrders] =
    useState<FetchMonthlyVisitReportType | null>(null);
  const [month, setMonth] = useState<number>(currentDate.getMonth() + 1);
  const [year, setYear] = useState<number>(currentDate.getFullYear());
  const [value, setValue] = useState(
    monthlyVisitOrders
      ? monthlyVisitOrders.monthlyVisitCounts[0].region[0].rbm_name
      : ""
  );

  const [open, setOpen] = useState<boolean>(false);
  const [downloadJson, setDownloadJson] = useState<DownloadJSON[]>([]);

  const [visitSummary, setVisitSummary] = useState<VisitSummaryType | null>(
    null
  );
  const [customerTypeId, setCustomerTypeId] = useState<string | null>(null);
  const [summaryLoading, setSummaryLoading] = useState<boolean>(false);

  const [isTabLoading, setIsTabLoading] = useState(false);
  const [isCalendarLoading, setIsCalendarLoading] = useState(false);
  const [isExpandLoading, setIsExpandLoading] = useState(false);
  const [isRegionLoading, setIsRegionLoading] = useState(false);
  const [regionGACode, setRegionGACode] = useState<string>("");
  const [selectedZoneGACode, setSelectedZoneGACode] = useState<string>("");

  useEffect(() => {
    decodeToken();
    fetchVisitCalendarData();
  }, []);

  const fetchVisitCalendarData = async () => {
    try {
      setMonth(month);
      setYear(year);
      let params = {
        customer_type_id: null,
        ga_code: null,
      };
      setIsCalendarLoading(true);
      setIsTabLoading(true);
      setIsExpandLoading(true);

      const monthlyVisitOrdersCalendarData = await fetchMonthlyVisitReport(
        month,
        year,
        params
      );
      if (monthlyVisitOrdersCalendarData.success) {
        setIsCalendarLoading(false);
        setIsTabLoading(false);
        setIsExpandLoading(false);
        setMonthlyVisitOrders(monthlyVisitOrdersCalendarData);
        setRegionGACode(
          monthlyVisitOrdersCalendarData?.monthlyVisitCounts[0]?.region[0]
            ?.region_ga_code
        );
      }
    } catch (error) {
      setSummaryLoading(false);
      setIsCalendarLoading(true);
      setIsTabLoading(true);
      setIsExpandLoading(true);
    }
  };

  const summaryVisitApi = async (summaryVisitParams: any) => {
    try {
      setSummaryLoading(true);
      setVisitSummary(null);
      const typeWiseVisitSummary = await fetchSummaryVisitReport(
        summaryVisitParams
      );

      if (typeWiseVisitSummary.success) {
        setVisitSummary(typeWiseVisitSummary.visit_summary);
      }
    } finally {
      setSummaryLoading(false);
    }
  };

  const fetchRegionGaCodeData = async () => {
    try {
      setSummaryLoading(true);
      const monthString = month.toString().padStart(2, "0");
      const summaryVisitParams = {
        month: monthString,
        year: year,
        ...(customerTypeId && { customer_type_id: customerTypeId ?? null }),
        ga_code: userRole.role === Roles.AREA_MANAGER ? null : regionGACode,
      };

      await summaryVisitApi(summaryVisitParams);
    } finally {
      setSummaryLoading(false);
    }
  };

  useEffect(() => {
    if (regionGACode && (!open || userRole.role === Roles.AREA_MANAGER)) {
      fetchRegionGaCodeData();
    }
  }, [regionGACode, month, year, customerTypeId]);

  useEffect(() => {
    if (
      monthlyVisitOrders &&
      monthlyVisitOrders.monthlyVisitCounts.length > 0
    ) {
      const initialRegion =
        monthlyVisitOrders?.monthlyVisitCounts[0]?.region.find(
          (region) => region.region_ga_code === "newValue"
        );
      if (initialRegion) {
        setValue(initialRegion.region_ga_code);
      } else {
        setValue(
          monthlyVisitOrders.monthlyVisitCounts[0]?.region[0]?.region_ga_code
        );
      }
    }
  }, [monthlyVisitOrders]);

  const handleChange = async (newValue: string) => {
    setValue(newValue);
    setDownloadJson([]);
    const monthString = month.toString().padStart(2, "0");
    let summaryVisitParams: SummaryVisitParams = {
      month: monthString,
      year: year,
      customer_type_id: reportFiltersComponent.customerType ?? null,
    };
    if (newValue && !open) summaryVisitParams.ga_code = newValue;
    summaryVisitApi(summaryVisitParams);
  };

  const filterData = async (filter: ReportFilters) => {
    let selectedGaCode = {} as TerritoryData | undefined;

    if (filter.zone.length > 0) {
      selectedGaCode = zoneMasterData.find(
        (item) => item.id.toString() === filter.zone[0]
      );
      setSelectedZoneGACode(selectedGaCode ? selectedGaCode.ga_code : "");
    } else {
      setSelectedZoneGACode("");
    }

    let params: MonthlyVistParams = {};

    if (filter.customerType) {
      params.customer_type_id = filter.customerType;
      setCustomerTypeId(filter.customerType);
    } else {
      setCustomerTypeId(null);
    }
    if (selectedGaCode?.ga_code) params.ga_code = selectedGaCode.ga_code;

    const month = parseInt(moment(filter.date?.toString()).format("MM"));
    const year = parseInt(moment(filter.date?.toString()).format("YYYY"));

    setMonth(month);
    setYear(year);
    const monthString = month.toString().padStart(2, "0");

    let summaryVisitParams: SummaryVisitParams = {
      month: monthString,
      year: year,
    };

    if (filter.customerType) {
      summaryVisitParams.customer_type_id = filter.customerType;
      setCustomerTypeId(filter.customerType);
    } else {
      setCustomerTypeId(null);
    }

    try {
      setSummaryLoading(true);
      setIsTabLoading(true);
      setIsCalendarLoading(true);
      setIsExpandLoading(true);

      const monthlyVisitOrdersCalendarData = await fetchMonthlyVisitReport(
        month,
        year,
        params
      );
      if (monthlyVisitOrdersCalendarData.success) {
        if (!open || userRole.role === Roles.AREA_MANAGER) {
          summaryVisitParams.ga_code =
            monthlyVisitOrdersCalendarData?.monthlyVisitCounts[0]?.region[0]
              ?.region_ga_code ?? null;
        } else {
          if (selectedGaCode?.ga_code)
            summaryVisitParams.ga_code = selectedGaCode.ga_code ?? null;
          summaryVisitApi(summaryVisitParams);
        }
        setIsCalendarLoading(false);
        setMonthlyVisitOrders(monthlyVisitOrdersCalendarData);
        setRegionGACode(
          monthlyVisitOrdersCalendarData?.monthlyVisitCounts[0]?.region[0]
            ?.region_ga_code
        );
      }
    } finally {
      setSummaryLoading(false);
      setIsTabLoading(false);
      setIsCalendarLoading(false);
      setIsExpandLoading(false);
    }
  };

  const clearData = async () => {
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    setMonth(month);
    setYear(year);
    const params = {
      customer_type_id: null,
      ga_code: null,
    };
    try {
        setSummaryLoading(true);
      setIsTabLoading(true);
      setIsCalendarLoading(true);
      setIsExpandLoading(true);
      const monthlyVisitOrders = await fetchMonthlyVisitReport(
        month,
        year,
        params
      );

      if (monthlyVisitOrders.success) {
        setMonthlyVisitOrders(monthlyVisitOrders);
      }
      const monthString = month.toString().padStart(2, "0");

      if (!open || userRole.role === Roles.AREA_MANAGER) {
        let summaryVisitParams: SummaryVisitParams = {
          month: monthString,
          year: year,
          ga_code: regionGACode ?? null,
        };
        summaryVisitApi(summaryVisitParams);
      } else {
        let summaryVisitParams: SummaryVisitParams = {
          month: monthString,
          year: year,
        };
        summaryVisitApi(summaryVisitParams);
      }
    } finally {
      setSummaryLoading(false);
      setIsTabLoading(false);
      setIsCalendarLoading(false);
      setIsExpandLoading(false);
    }
  };

  const downloadFile = () => {
    const reversedDownloadJson = downloadJson.slice().reverse();
    const headers = [
      "role",
      "user",
      "territory",
      "total",
      ...Object.keys(reversedDownloadJson[0]).filter(
        (key) => !["role", "user", "territory", "total"].includes(key)
      ),
    ];
    const ws = XLSX.utils.json_to_sheet(reversedDownloadJson, {
      header: headers,
    });

    const colWidths = headers.map((header) => ({ wch: header.length + 5 }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "output.xlsx");
  };

  const changeExpandAll = async () => {
    setIsRegionLoading(true);
    setDownloadJson([]);
    setOpen(!open);
    setMonth(month);
    setYear(year);

    const monthString = month.toString().padStart(2, "0");

    if (!open || userRole.role === Roles.AREA_MANAGER) {
      setValue(
        monthlyVisitOrders?.monthlyVisitCounts[0]?.region[0]?.region_ga_code ??
          ""
      );
      let summaryVisitParams: SummaryVisitParams = {
        month: monthString,
        year: year,
        customer_type_id: reportFiltersComponent.customerType ?? null,
        ...(selectedZoneGACode && { ga_code: selectedZoneGACode ?? null }),
      };
      summaryVisitApi(summaryVisitParams);
    } else {
      setValue(
        monthlyVisitOrders?.monthlyVisitCounts[0]?.region[0]?.region_ga_code ??
          ""
      );
      let summaryVisitParams: SummaryVisitParams = {
        month: monthString,
        year: year,
        ga_code: regionGACode,
        customer_type_id: reportFiltersComponent.customerType ?? null,
      };
      summaryVisitApi(summaryVisitParams);
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsRegionLoading(false);
  };

  return (
    <>
      <Typography variant="h5" fontWeight={550}>
        Daily Visit Report
      </Typography>
      {Object.keys(userDetails).length > 0 ? (
        <ReportFiltersComponent
          type={ReportScreen.DAILY_VISIT_REPORT}
          successCallback={filterData}
          clearSuccessCallBack={clearData}
          userRole={userRole.role}
          userDetails={userDetails}
          gridColumns={25}
          territoryMultiSelect={false}
        />
      ) : (
        <ReportFiltersLoading />
      )}
      <Stack direction={"row"} gap={2}>
        {userRole.role !== Roles.AREA_MANAGER && (
          <Button
            variant="contained"
            sx={{ width: "150px" }}
            onClick={changeExpandAll}
            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          >
            {open ? "Collapse" : "Expand All"}
          </Button>
        )}
        <Button variant="contained" onClick={downloadFile}>
          Download
        </Button>
      </Stack>

      {open ? (
        <Stack gap={3} py={1} borderRadius={3}>
          <>
            {isExpandLoading || summaryLoading ? (
              <>
                <DailyVisitSummaryLoading />
                <DailyVisitTabCalendarLoader type="expandCalendar" />
              </>
            ) : (
              <>
                {visitSummary && <DataSummary visitSummary={visitSummary} />}
                {monthlyVisitOrders?.monthlyVisitCounts?.map(
                  (visitCount, key) => (
                    <React.Fragment key={key}>
                      {visitCount.region.map((region, key) => (
                        <Stack gap={3} key={key}>
                          <Typography variant="h6">
                            {region.rbm_name}
                          </Typography>
                          {isRegionLoading ? (
                            <>
                              <CircularProgress />
                            </>
                          ) : (
                            <RegionWiseDailyVisit
                              data={region}
                              month={month}
                              year={year}
                              downloadJson={downloadJson}
                              customerTypeId={customerTypeId}
                            />
                          )}
                        </Stack>
                      ))}
                    </React.Fragment>
                  )
                )}
              </>
            )}
          </>
        </Stack>
      ) : (
        <Stack gap={1} py={1} borderRadius={3}>
          <TabContext value={value}>
            {isTabLoading ? (
              <DailyVisitTabCalendarLoader type="tab" />
            ) : userRole.role !== Roles.AREA_MANAGER ? (
              <TabList sx={{ display: "flex", overflow: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    overflowX: "auto",
                    padding: "10px",
                    marginBottom: "10px",
                    "&::-webkit-scrollbar": {
                      height: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {monthlyVisitOrders?.monthlyVisitCounts?.map(
                    (visitCount, orderIndex) => (
                      <React.Fragment key={orderIndex}>
                        {visitCount.region.map((region, regionIndex) => (
                          <Box
                            key={regionIndex}
                            sx={{
                              borderBottom:
                                value === region.region_ga_code
                                  ? "2px solid blue"
                                  : "none",
                              minWidth: "auto",
                            }}
                          >
                            <Tab
                              label={region.rbm_name}
                              value={region.region_ga_code}
                              onClick={() => {
                                handleChange(region.region_ga_code);
                              }}
                            />
                          </Box>
                        ))}
                      </React.Fragment>
                    )
                  )}
                </Box>
              </TabList>
            ) : (
              <></>
            )}

            {summaryLoading ? (
              <DailyVisitSummaryLoading />
            ) : (
              visitSummary && <DataSummary visitSummary={visitSummary} />
            )}

            {isCalendarLoading ? (
              <DailyVisitTabCalendarLoader type="calendar" />
            ) : (
              monthlyVisitOrders?.monthlyVisitCounts?.map(
                (visitCount, visitIndex) => (
                  <Stack key={visitIndex}>
                    {visitCount.region.map((region, regionIndex) => (
                      <TabPanel
                        key={`${visitIndex}-${regionIndex}`}
                        value={region.region_ga_code}
                      >
                        <RegionWiseDailyVisit
                          data={region}
                          month={month}
                          year={year}
                          downloadJson={downloadJson}
                          customerTypeId={customerTypeId}
                        />
                      </TabPanel>
                    ))}
                  </Stack>
                )
              )
            )}
          </TabContext>
        </Stack>
      )}
    </>
  );
};

export default DailyVisitReportTable;
